/* ==========================================================================
   Midwest Ponds 2026 collection page: AJAX filters + sort (Section Rendering
   API), filter drawer on phones, load more, description clamp.
   Without JS the filter form and links still work as plain GET requests.
   ========================================================================== */
(function () {
  'use strict';
  var d = document;
  var M = window.IvpTheme || {};
  function qs(s, el) { return (el || d).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); }

  function init(root) {
    var sectionId = root.getAttribute('data-section-id');
    var mobile = window.matchMedia('(max-width: 999px)');
    var busy = null;

    /* ---------- Description clamp ---------- */
    var clamp = qs('[data-ivp-clamp]', root);
    if (clamp) {
      var btn = qs('[data-ivp-clamp-toggle]', clamp);
      if (btn) {
        btn.addEventListener('click', function () {
          var open = clamp.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.firstChild.textContent = open ? 'Read less ' : 'Read more ';
        });
      }
    }

    /* ---------- Filter drawer (phones) ---------- */
    var panel = qs('[data-ivp-filters]', root);
    var overlay = null;
    function openFilters() {
      if (!panel) return;
      if (!overlay) {
        overlay = d.createElement('div');
        overlay.className = 'ivp-overlay ivp-overlay--top';
        d.body.appendChild(overlay);
        overlay.addEventListener('click', closeFilters);
      }
      panel.classList.add('is-open');
      overlay.classList.add('is-visible');
      M.lock && M.lock();
      var c = qs('[data-ivp-filters-close]', panel); if (c) c.focus();
    }
    function closeFilters() {
      if (!panel || !panel.classList.contains('is-open')) return;
      panel.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      M.unlock && M.unlock();
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ivp-filters-open]')) { e.preventDefault(); openFilters(); return; }
      var closer = e.target.closest('[data-ivp-filters-close]');
      if (closer) {
        if (closer.type === 'submit' && !mobile.matches) return;
        e.preventDefault();
        closeFilters();
        return;
      }
      var more = e.target.closest('[data-ivp-filter-more]');
      if (more) { var list = more.previousElementSibling; list.classList.remove('is-long'); more.remove(); }
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilters(); });

    /* ---------- AJAX ---------- */
    function sectionUrl(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      return u.toString();
    }
    function cleanUrl(url) {
      var u = new URL(url, window.location.origin);
      u.searchParams.delete('section_id');
      return u.pathname + (u.search ? u.search : '');
    }

    function render(url, push) {
      if (busy) busy.abort();
      busy = window.AbortController ? new AbortController() : null;
      root.classList.add('is-loading');
      return fetch(sectionUrl(url), { signal: busy ? busy.signal : undefined })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // results
          var fresh = qs('[data-ivp-coll-results]', doc), cur = qs('[data-ivp-coll-results]', root);
          if (fresh && cur) cur.replaceWith(fresh);
          // counts + filter badge
          ['[data-ivp-results-count]', '[data-ivp-filters-open]'].forEach(function (sel) {
            var a = qs(sel, doc), b = qs(sel, root);
            if (a && b) b.innerHTML = a.innerHTML;
          });
          // filters: keep which groups are open
          var fs = qs('[data-ivp-filters] .ivp-filters__scroll', doc), cs = qs('[data-ivp-filters] .ivp-filters__scroll', root);
          if (fs && cs) {
            var openState = qsa('details', cs).map(function (x) { return x.open; });
            var top = cs.scrollTop;
            cs.innerHTML = fs.innerHTML;
            qsa('details', cs).forEach(function (x, i) { if (openState[i] !== undefined) x.open = openState[i]; });
            cs.scrollTop = top;
          }
          var ff = qs('[data-ivp-filters] .ivp-filters__foot', doc), cf = qs('[data-ivp-filters] .ivp-filters__foot', root);
          if (ff && cf) cf.innerHTML = ff.innerHTML;
          if (push !== false) history.pushState({ ivpColl: true }, '', cleanUrl(url));
          root.classList.remove('is-loading');
          d.dispatchEvent(new CustomEvent('ivp:collection:rendered'));
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') { root.classList.remove('is-loading'); window.location.href = url; } });
    }

    function formUrl() {
      var form = qs('[data-ivp-filter-form]', root);
      var u = new URL(form ? form.action : window.location.pathname, window.location.origin);
      if (form) {
        new FormData(form).forEach(function (v, k) { if (v !== '' && v != null) u.searchParams.append(k, v); });
      }
      var sort = qs('[data-ivp-sort]', root);
      if (sort && sort.value !== sort.getAttribute('data-default')) u.searchParams.set('sort_by', sort.value);
      return u.pathname + u.search;
    }

    var priceTimer = null;
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-ivp-sort]')) { render(formUrl()); return; }
      if (t.closest('[data-ivp-filter-form]')) {
        if (t.type === 'number') { clearTimeout(priceTimer); priceTimer = setTimeout(function () { render(formUrl()); }, 500); return; }
        render(formUrl());
      }
    });
    root.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-ivp-filter-form]')) return;
      e.preventDefault();
      render(formUrl());
      if (mobile.matches) closeFilters();
    });
    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-ivp-filter-link], [data-ivp-filter-clear]');
      if (link) { e.preventDefault(); render(link.href); return; }

      var more = e.target.closest('[data-ivp-load-more]');
      if (more) {
        e.preventDefault();
        M.setLoading && M.setLoading(more, true);
        fetch(sectionUrl(more.href)).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = qs('[data-ivp-coll-grid]', root);
          var freshGrid = qs('[data-ivp-coll-grid]', doc);
          if (grid && freshGrid) {
            Array.prototype.slice.call(freshGrid.children).forEach(function (c) { grid.appendChild(c); });
          }
          var paging = qs('.ivp-coll__paging', root), freshPaging = qs('.ivp-coll__paging', doc);
          if (paging && freshPaging) {
            var from = paging.getAttribute('data-from');
            freshPaging.setAttribute('data-from', from);
            var fromEl = qs('[data-ivp-from]', freshPaging);
            if (fromEl) fromEl.textContent = from;
            if (from === '1') freshPaging.classList.remove('ivp-coll__paging--deep');
            paging.replaceWith(freshPaging);
          } else if (paging) paging.remove();
          history.replaceState({ ivpColl: true }, '', cleanUrl(more.href));
        }).catch(function () { window.location.href = more.href; });
      }
    });

    window.addEventListener('popstate', function () { render(window.location.href, false); });
  }

  function boot() { qsa('[data-ivp-collection]').forEach(init); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
